<template>
  <span
    class="inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-semibold leading-5 ring-1 ring-inset"
    :class="badgeClasses"
  >
    {{ tag }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { badgeClassesForContextColor } from '@/utils/siteContextBadge';

const props = defineProps({
  tag: {
    type: String,
    required: true,
  },
  colorToken: {
    type: String,
    default: 'code-medical-center',
  },
});

const badgeClasses = computed(() => badgeClassesForContextColor(props.colorToken));
</script>
